var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"lock-scroll":false,"custom-class":"lexicon-container","width":"1050px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('List',{on:{"close":function($event){return _vm.changeLexicon(false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }